module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/assessment_achievements/4_4ad03f8374144125c098d3692bd8dfed.png";